import { render, staticRenderFns } from "./centerList.vue?vue&type=template&id=2b802a53&scoped=true&"
import script from "./centerList.vue?vue&type=script&lang=js&"
export * from "./centerList.vue?vue&type=script&lang=js&"
import style0 from "./centerList.vue?vue&type=style&index=0&id=2b802a53&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b802a53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b802a53')) {
      api.createRecord('2b802a53', component.options)
    } else {
      api.reload('2b802a53', component.options)
    }
    module.hot.accept("./centerList.vue?vue&type=template&id=2b802a53&scoped=true&", function () {
      api.rerender('2b802a53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/centerEdition/centerList.vue"
export default component.exports